// extracted by mini-css-extract-plugin
export default {"icon-toggle":"App_icon-toggle_fXrnA","content-body":"App_content-body_ymr_Z","custom-table":"App_custom-table_qc61y","container":"App_container_jzqtp"};